import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./ExploreGamesPage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import ImageExploreGames from "../../../images/explore-games.png";
import ImageSigmaGamesLogo from "../../../images/sigma-games-logo.png";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import { ROUTES } from "../../../utils/constants";

function ExploreGamesPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const handleExploreGames = () => {
    navigate(ROUTES.ROOT.HOME);
  };

  return (
    <OnboardingContainer className="explore-games-page">
      <div>
        <Link to="/">
          <Image src={ImageSigmaGamesLogo} width={115} />
        </Link>{" "}
      </div>

      <Stack className="align-items-center justify-content-end main-content">
        <div className="image-container">
          <Image
            src={ImageExploreGames}
            className="explore-games-image"
            width={170}
          />
          <p className="all-access-badge">{t("onboarding.all_access")}</p>
        </div>
        <Stack gap={2} className="text-content">
          <h1 className="primary-copy">
            {t("onboarding.all_games_one_place")}
          </h1>
          <h6 className="secondary-copy">
            {t(
              "onboarding.play_your_favorite_games_instantly_with_no_additional_installs_or_ads"
            )}
            {t("punctuations.full_stop")}
          </h6>
        </Stack>
        <PrimaryActionButton
          size="lg"
          text={t("onboarding.explore_games")}
          buttonClassName="explore-games-button"
          onClick={handleExploreGames}
        />
      </Stack>
    </OnboardingContainer>
  );
}

export default ExploreGamesPage;
